import React, { useState,useEffect } from "react";
import "../Styles/CompetitiveAnalysis.scss";
import "../../examReview.scss";
import { useDetails } from "../../DetailsContext";
const CompetitiveAnalysis = ({ result }) => {
  const { details, setDetails } = useDetails();
  const [currentData,setCurrentData]=useState();
  const [current, setCurrent] = useState("Overall");
  const [sectionsData, setSectionsData] = useState({});
  
  useEffect(() => {
    if (result && result.competetiveAnalysis) {
      const dataObj = result.competetiveAnalysis.reduce((acc, section) => {
        acc[section.section] = section.data;
        setCurrent(section.section);
        return acc;
      }, {});

      // Calculate overall data
      const overallData = result.competetiveAnalysis.reduce((overall, section) => {
        section.data.forEach((metric, index) => {
          if (!overall[index]) {
            overall[index] = { ...metric, values: [{ who: "you", value: 0 }, { who: "topper", value: 0 }] };
          }
          overall[index].values[0].value += parseFloat(metric.values[0].value);
          overall[index].values[1].value += parseFloat(metric.values[1].value);
        });
        return overall;
      }, []);

      dataObj["Overall"] = overallData;
      setSectionsData(dataObj);
    }
  }, [result]);

  useEffect(() => {
     
      setCurrentData(sectionsData?.[current]);
    
  }, [current,sectionsData]);

  // console.table("first",result,);;

  return (
    <div className="CompetitiveAnalysisWrapper">
      <div className="headingdiv ">
        <div className="heading">Competitive analysis</div>
        <div className="overalldiv">
          <div
            className={`${current === "Overall" ? "text" : "type"}`}
            onClick={() => setCurrent("Overall")}
          >
            Overall
          </div>
          <div className="components">
            {result?.sectionalMarkings.map((temp) => {
              return (
                <div
                  onClick={() => setCurrent(temp?.section)}
                  className={`${temp?.section === current ? "text" : "type"}`}
                >
                  {temp?.section}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div class="search-boxen">
        <div className="search-result">
          <div className="benchmarks table">
            <ul className="table-header">
              <li className="th"></li>
              <li className="th">
                <label>Score</label>
              </li>
              <li className="th">
                <label>Attempt</label>
              </li>
              <li className="th">
                <label>Time</label>
              </li>
              <li className="th">
                <label>Accuracy</label>
              </li>
            </ul>

            <ul className="table-body">
              <li className="tr">
                <span className="metric td">
                  You {console.log(result, "hrere")}{" "}
                </span>
                <span className="td bordercolor  percentile-76 textcolor">
                  <span className="number textcolor textcolor">
                    {currentData?.[0]?.values[0]?.value} 
                  
                  </span>
                </span>
                <span className="td bordercolor percentile-87">
                  <span className="number textcolor">
                  {currentData?.[1]?.values[0]?.value} 
                  </span>
                </span>
                <span className="td bordercolor percentile-32">
                  <span className="number textcolor">
                  {currentData?.[2]?.values[0]?.value}  min
                  </span>
                </span>
                <span className="td bordercolor percentile-32">
                  <span className="number textcolor">
                  {currentData?.[3]?.values[0]?.value} %
                  </span>
                </span>
              </li>
              <li className="tr">
                <span className="metric td">Average </span>
                <span className="td bordercolor percentile-67">
                  <span className="number textcolor">
                    67 / <span className="bottom-text"> 100</span>
                  </span>
                </span>
                <span className="td bordercolor percentile-98">
                  <span className="number textcolor">
                    98 / <span className="bottom-text"> 100</span>
                  </span>
                </span>
                <span className="td bordercolor percentile-42">
                  <span className="number textcolor">56 min</span>
                </span>
                <span className="td bordercolor percentile-42">
                  <span className="number textcolor">42%</span>
                </span>
              </li>
              <li className="tr">
                <span className="metric td">Topper</span>
                <span className="td bordercolor percentile-60">
                  <span className="number textcolor">
                    {currentData?.[0]?.values[1]?.value} 
                  </span>
                </span>
                <span className="td bordercolor percentile-91">
                  <span className="number textcolor">
                  {currentData?.[1]?.values[1]?.value} 
                  </span>
                </span>
                <span className="td bordercolor percentile-38">
                  <span className="number textcolor">
                  {currentData?.[2]?.values[1]?.value}  min
                  </span>
                </span>
                <span
                  style={{ "border-bottom-right-radius": "30px" }}
                  className="td bordercolor percentile-38"
                >
                  <span className="number textcolor">
                  {currentData?.[3]?.values[1]?.value} %
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <legend></legend>
        </div>
      </div>


      {/* <div
        style={{
          display: "flex",
          paddingLeft: "1.25rem",
          paddingRight: "1.25rem",
          marginTop: "2.5rem",
          gap: "1rem",
          alignSelf: "flex-start",
          fontSize: "1.05rem",
          // lineHeight: "2rem",
          fontWeight: 500,
          color: "#ffffff",
          whiteSpace: "nowrap",
        }}
      >
        <div
          style={{
            paddingTop: "1.25rem",
            paddingBottom: "1.25rem",
            paddingLeft: "2.5rem",
            paddingRight: "2.5rem",
            justifyContent: "center",
            borderRadius: "1rem",
            backgroundColor: "#004AAD",
          }}
        >
          Weakness
        </div>
        <div
          style={{
            paddingTop: "1.25rem",
            paddingBottom: "1.25rem",
            paddingLeft: "2.5rem",
            paddingRight: "2.5rem",
            justifyContent: "center",
            borderRadius: "1rem",
            backgroundColor: "#004AAD",
          }}
        >
          Opportunities
        </div>
        <div
          style={{
            paddingTop: "1.25rem",
            paddingBottom: "1.25rem",
            paddingLeft: "2.5rem",
            paddingRight: "2.5rem",
            justifyContent: "center",
            borderRadius: "1rem",
            backgroundColor: "#004AAD",
          }}
        >
          Strength
        </div>
      </div> */}
    </div>
  );
};

export default CompetitiveAnalysis;
